import { api, ApiError } from "@/api/api";
import { StoryGenerationMetadata } from "@/api/stories-types";
import { useQuery } from "@tanstack/react-query";

export function useStoryGenerationMetadata(episodeId: string | undefined) {
  return useQuery<StoryGenerationMetadata, ApiError>({
    queryKey: ["GET", "storyGenerationMetadata", episodeId],
    queryFn: () => api.stories.episodeId.metadata.get(episodeId!),
    enabled: !!episodeId,
  });
}
